import React, { ReactNode } from "react"

const AccordionContainer = ({ children }: { children?: ReactNode }) => {
    return (
        <>
            <div className="accordion row" id="accordionExample">
                {children}
            </div>
        </>
    )
}

export default AccordionContainer